
import { Button, Col, Form, notification, Radio, Row, Spin } from 'antd'
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { addPhenoTypeAnalysisApi, listOfPhenoTypeAnalysisApi, listOfPhenotypeQuestionApi } from '../../../../../../config/Api';
import { API_ERR_MESSAGE } from '../../../../../../config/constant';
import '../../style/PhenotypeAnalysis.scss'

export const PhenotypeAnalysis = (props) => {
    const [form] = Form.useForm();
    const { id } = useParams()

    const [phenotypeAnalysisQuestions, setPhenotypeAnalysisQuestions] = useState([]);
    const [phenotypeAnalysisAnswers, setPhenotypeAnalysisAnswers] = useState([]);
    // in this state we store the array of exist Q & A that is given by user   
    const [phenotypeAnalysisExistAnswers, setPhenotypeAnalysisExistAnswers] = useState([]);
    const [formData, setFormData] = useState([]);
    const [kaphaCount, setkaphaCount] = useState(0);
    const [pittaCount, setPittaCount] = useState(0);
    const [vataCount, setVataCount] = useState(0);

    const [kaphaPercentage, setkaphaPercentage] = useState(0);
    const [pittaPercentage, setPittaPercentage] = useState(0);
    const [vataPercentage, setVataPercentage] = useState(0);

    const [loading, setLoading] = useState(false)

    const fillAnswer = (QWithAnswer) => {
        // console.log(QWithAnswer);
        // // if user has already given answers then display it first
        // if (QWithAnswer.length > 0) {
        //     QWithAnswer.map((record) => {
        //         // console.log(record.phenotype_question_id)
        //         const element = QWithAnswer.find((element1) => element.id == element1.phenotype_question_id)
        //         element.answer = record.answer
        //         element.answerType = record.answerType
        //     }
        //     )
        //     console.log(QWithAnswer);
        //     console.log(phenotypeAnalysisQuestions);
        // }

        // fill the form data object on page load if user answer exist then fill that data on that state  

        if (QWithAnswer.length > 0) {
            // setFormData([])
            QWithAnswer.map((record) =>
                formData.push({
                    "id": record?.phenotype_question_id,
                    "question_domain_id": record?.question_domain_id,
                    "question": record?.question,
                    "kapha": record?.kapha,
                    "pitta": record?.pitta,
                    "vata": record?.vata,
                    "status": true,
                    "created_at": record?.created_at,
                    "updated_at": record?.updated_at,
                    "question_domain": {
                        "id": record?.question_domain?.id,
                        "domain": record?.question_domain?.domain,
                        "status": record?.question_domain?.status,
                        "created_at": record?.question_domain?.created_at,
                        "updated_at": record?.question_domain?.updated_at
                    },
                    "answer": record?.answer,
                    "answerType": record?.answerType
                })
            )
            // console.log(formData);
            let kaphaData = formData.filter(Qdata => Qdata.answerType == "kapha")
            let PittaData = formData.filter(Qdata => Qdata.answerType == "pitta")
            let VataData = formData.filter(Qdata => Qdata.answerType == "vata")
            setPittaCount(PittaData.length)
            setVataCount(VataData.length)
            setkaphaCount(kaphaData.length)
            setPhenotypeAnalysisAnswers(formData)
        }
    }

    // list of all questions with its answer given by patient 
    // =========================
    const getListOfPhenotypeAnalysisQAndA = () => {
        setLoading(true)

        listOfPhenoTypeAnalysisApi({
            "patient_id": parseInt(id)
        }).then((res) => {
            if (res.status === 200) {
                setPhenotypeAnalysisExistAnswers(res.data.data)

                // fill the exist answers  
                // =========================
                let QWithAnswer = res.data.data
                let temp = []
                if (QWithAnswer.length > 0) {
                    // setFormData([])
                    QWithAnswer.map((record) =>
                        temp.push({
                            "id": record?.phenotype_question_id,
                            "question_domain_id": record?.question_domain_id,
                            "question": record?.question,
                            "kapha": record?.kapha,
                            "pitta": record?.pitta,
                            "vata": record?.vata,
                            "status": true,
                            "created_at": record?.created_at,
                            "updated_at": record?.updated_at,
                            "question_domain": {
                                "id": record?.question_domain?.id,
                                "domain": record?.question_domain?.domain,
                                "status": record?.question_domain?.status,
                                "created_at": record?.question_domain?.created_at,
                                "updated_at": record?.question_domain?.updated_at
                            },
                            "answer": record?.answer,
                            "answerType": record?.answerType
                        })
                    )

                    // calculate total kapha pitta and vata
                    // =========================
                    // console.log(formData);
                    setFormData(temp)
                    let kaphaData = temp.filter(Qdata => Qdata.answerType == "kapha")
                    let PittaData = temp.filter(Qdata => Qdata.answerType == "pitta")
                    let VataData = temp.filter(Qdata => Qdata.answerType == "vata")
                    setPittaCount(PittaData.length)
                    setVataCount(VataData.length)
                    setkaphaCount(kaphaData.length)
                    setPhenotypeAnalysisAnswers(formData)


                    // calculate the percentage
                    // =========================
                    let totalQuestions = temp.length
                    setkaphaPercentage(parseInt((kaphaData.length * 100) / totalQuestions))
                    setPittaPercentage(parseInt((PittaData.length * 100) / totalQuestions))
                    setVataPercentage(parseInt((VataData.length * 100) / totalQuestions))
                }
                // console.log(res.data.data)
                // }
            }
            setLoading(false)
        })
            .catch((err) => {
                // console.log(err);
                // notification.error({
                //     message: err,
                // });
            });
    }

    // list of all questions without its answer 
    const getListOfPhenotypeAnalysisQuestions = () => {
        setLoading(true)

        listOfPhenotypeQuestionApi()
            .then((res) => {
                if (res.status === 200) {
                    setPhenotypeAnalysisQuestions(res.data.data);
                    setPhenotypeAnalysisAnswers(res.data.data);
                    // console.log("quesion", res.data.data);
                }
                setLoading(false)
            })
            .catch((err) => {
                notification.error({
                    message: 'something went wrong',
                });
            });
    }

    useEffect(() => {
        // console.log(formData);
        getListOfPhenotypeAnalysisQAndA()
        getListOfPhenotypeAnalysisQuestions()
    }, []);

    const handleSelection = async (answer, element, index) => {
        // console.log(phenotypeAnalysisAnswers);
        // console.log(element.id);
        // let questionData = phenoTypeQuestions[index];
        let questionDataA = phenotypeAnalysisAnswers[index];
        let questionData = questionDataA;
        // get the key name of answer like kapha,vata ot pitta
        // let keyName = Object.keys(element).find(key => element[key].value == answer);
        // console.log("questionData", questionData)
        // console.log("element", element)
        // console.log(answer)
        // if(questionData){}
        let keyName = Object.keys(questionData).find(key => questionData[key] == answer);
        // console.log(keyName)
        // console.log("questionData", questionData)
        // console.log("element", element)
        // check if answer of question is available in formData state 
        const isRecordExist = formData.find((ele) => ele.id == questionData.id)
        if (isRecordExist) {
            // if  true then update answer
            // console.log("isRecordExist", isRecordExist)
            formData.find((e, index) => {
                if (e.id == questionData.id) {
                    formData[index].answer = answer;
                    formData[index].answerType = keyName;
                }
            })
            // console.log("formData", formData)

        } else {
            // else store in formData state question answer data
            questionData.answer = answer;
            // delete questionData.kapha;
            // delete questionData.pitta;
            // delete questionData.vata;
            // delete questionData.type;
            // console.log(questionData)
            // formData.push({answerType: keyName})
            // console.log(formData)
            formData.push(Object.assign(questionData, { answerType: keyName }))
            // console.log(formData)
        }

        // code for count answer types 
        let kaphaData = formData.filter(Qdata => Qdata.answerType == "kapha")
        let PittaData = formData.filter(Qdata => Qdata.answerType == "pitta")
        let VataData = formData.filter(Qdata => Qdata.answerType == "vata")
        setPittaCount(PittaData.length)
        setVataCount(VataData.length)
        setkaphaCount(kaphaData.length)

        // calculate the percentage
        let totalQuestions = phenotypeAnalysisAnswers.length
        // console.log("totalQuestions", totalQuestions)
        setkaphaPercentage(parseInt((kaphaData.length * 100) / totalQuestions))
        setPittaPercentage(parseInt((PittaData.length * 100) / totalQuestions))
        setVataPercentage(parseInt((VataData.length * 100) / totalQuestions))
    }

    // code to insert data with user given answers
    const onFinish = (values) => {
        // console.log(formData)
        let apiData;
        if (formData.length > 0) {
            // modify the response as expected
            formData.map((record) => {
                record.phenotype_question_id = record?.id
                delete record?.question_domain,
                    delete record?.created_at,
                    delete record?.updated_at,
                    delete record?.status
                delete record?.id
            }
            )
            apiData = {
                "patient_id": parseInt(id),
                "phenotype_analysis": formData
            }

            // console.log(apiData);
            // call api to insert phenotype analysis answers
            addPhenoTypeAnalysisApi(id, apiData)
                .then((res) => {
                    if (res.status == 200) {
                        notification.success({
                            message: "Response Save successfully",
                        });
                        getListOfPhenotypeAnalysisQAndA()
                        props.onSaved && props.onSaved()
                    }
                })
                .catch((err) => {
                    notification.error({
                        message: API_ERR_MESSAGE,
                    });
                });
        }
    };

    // clear form data
    const resetData = () => {
        form.resetFields()
        setFormData([])
        setkaphaCount(0)
        setPittaCount(0)
        setVataCount(0)
        setkaphaPercentage(0)
        setPittaPercentage(0)
        setVataPercentage(0)
    };

    const phenoTypeQuestions = [
        {
            id: 1, // question id,
            type_id: 101,
            type: { name: "Lifestyle" },
            question: "How do you see your lifestyle?",
            // isRequired: true,
            kapha: "It is often changing (Erratic) and I don’t feel pressured with responsibilities",
            pitta: "It is normally well planned or I prefer working in planned way",
            vata: "I feel its regular and easy going for me"
        },
        {
            id: 2, // question id,
            type_id: 102,
            type: { name: "Activity" },
            question: "How is your activity level? How much you like sitting or you feel lively most of the time and feel restless when sitting?",
            // isRequired: true,
            kapha: "I love moving around or like movement throughout the day. While sitting I feel restless",
            pitta: "I feel energetic and active throughout the day, enjoy exercise and I also enjoy competition",
            vata: "I like being sitting and working most of the time. I take time to finish my tasks"
        },
        {
            id: 3, // question id,
            type_id: 103,
            type: { name: "Body Frame" },
            question: "How does your body frame/ body type/ frame size, look like?",
            // isRequired: true,
            kapha: "Usually thin and I am underweight",
            pitta: "I am medium built and have some weight issues",
            vata: "I am broad and weight is on heavy side"
        },
        {
            id: 4, // question id,
            type_id: 104,
            type: { name: "Body Temperature" },
            question: "How is your body temperature?",
            // isRequired: true,
            kapha: "I Feel colder than others",
            pitta: "I feel hotter than others",
            vata: "Normal body temperature"
        },
        {
            id: 5, // question id,
            type_id: 105,
            type: { name: "Appetite" },
            question: "How is you appetite (desire to have food)?",
            // isRequired: true,
            kapha: "Irregular and erratic inconsistent. At times I feel like eating a lot but at times I just don’t feel hungry",
            pitta: "Strong and I cannot skip my meals",
            vata: "Low and constant but it is easy to skip the meal"
        },
    ]

    return (
        <div className='PhenotypeAnalysis'>

            <Row className="table-data">
                <Col span={24} className="form-header">Patient's Phenotype</Col>

                <Col xs={12} sm={12} md={6} lg={6} xl={{ offset: 4, span: 5 }}>
                    <span className="Title"> First Dominant</span>
                </Col>
                <Col xs={12} sm={12} md={4} lg={4} xl={2}>
                    <span className="content"> Kapha</span>
                </Col>
                <Col xs={12} sm={12} md={3} lg={3} xl={4}>
                    <span className="Title">Count</span>
                </Col>
                <Col xs={12} sm={12} md={3} lg={3} xl={1}>
                    <span className="content"> {kaphaCount}</span>
                </Col>
                <Col xs={12} sm={12} md={4} lg={4} xl={3}>
                    <span className="Title">Percentage</span>
                </Col>
                <Col xs={12} sm={12} md={3} lg={3} xl={2}>
                    <span className="content">{kaphaPercentage} %</span>
                </Col>

                <Col xs={12} sm={12} md={6} lg={6} xl={{ offset: 4, span: 5 }}>
                    <span className="Title"> Second Dominant</span>
                </Col>
                <Col xs={12} sm={12} md={4} lg={4} xl={2}>
                    <span className="content"> Pitta</span>
                </Col>
                <Col xs={12} sm={12} md={3} lg={3} xl={4}>
                    <span className="Title">Count</span>
                </Col>
                <Col xs={12} sm={12} md={3} lg={3} xl={1}>
                    <span className="content"> {pittaCount}</span>
                </Col>
                <Col xs={12} sm={12} md={4} lg={4} xl={3}>
                    <span className="Title">Percentage</span>
                </Col>
                <Col xs={12} sm={12} md={3} lg={3} xl={2}>
                    <span className="content">  {pittaPercentage} %</span>
                </Col>

                <Col xs={12} sm={12} md={6} lg={6} xl={{ offset: 4, span: 5 }}>
                    <span className="Title"> Recessive</span>
                </Col>
                <Col xs={12} sm={12} md={4} lg={4} xl={2}>
                    <span className="content"> Vata</span>
                </Col>
                <Col xs={12} sm={12} md={3} lg={3} xl={4}>
                    <span className="Title">Count</span>
                </Col>
                <Col xs={12} sm={12} md={3} lg={3} xl={1}>
                    <span className="content"> {vataCount}</span>
                </Col>
                <Col xs={12} sm={12} md={4} lg={4} xl={3}>
                    <span className="Title">Percentage</span>
                </Col>
                <Col xs={12} sm={12} md={3} lg={3} xl={2}>
                    <span className="content">  {vataPercentage} %</span>
                </Col>

            </Row>
            <Row gutter={[6, { xs: 8, sm: 8, md: 8, lg: 8 }]} className="form-header">
                <Col xs={24} sm={12} md={5} lg={5} xl={2}>Domain</Col>
                <Col xs={24} sm={12} md={5} lg={5} xl={9}>	Question</Col>
                <Col xs={24} sm={24} md={24} lg={24} xl={13} xxl={13} >Answers (Select one for each question)</Col>
            </Row>
            <Spin spinning={loading} className="spinner-code">
                <Form
                    name="PhenotypeAnalysisForm"
                    className="PhenotypeAnalysisForm"
                    form={form}
                    onFinish={onFinish}
                >
                    {
                        // phenoTypeQuestions.map((element, index) => (
                        phenotypeAnalysisQuestions.map((element, index) => (
                            <Row gutter={[{ xs: 0, sm: 8, md: 8, lg: 8 }, { xs: 0, sm: 8, md: 8, lg: 8 }]} key={index} id={element?.id} className="question_list">
                                {/* {console.log("elemenmt", element)} */}
                                <Col xs={24} sm={6} md={4} lg={4} xl={2} xxl={2} >
                                    <Form.Item name={"type_name" + index} className="type_name">
                                        {/* {console.log("dddd", element)} */}
                                        <p value={element?.question_domain?.domain}>{element?.question_domain?.domain}</p>
                                    </Form.Item>
                                </Col>
                                <Col xs={24} sm={18} md={18} lg={18} xl={9} xxl={9}>
                                    <Form.Item name={"question" + index} className="question">
                                        <p>{element?.question}</p>
                                    </Form.Item>
                                </Col>
                                <Col xs={24} sm={24} md={24} lg={24} xl={13} xxl={13} >
                                    <Form.Item name={'answer' + index} className="options"
                                        rules={[
                                            {
                                                required: true,
                                                message: "Please Select!",
                                            },
                                        ]}
                                        initialValue={phenotypeAnalysisExistAnswers.length > 0
                                            && phenotypeAnalysisExistAnswers.find((element1) => element.id == element1.phenotype_question_id)?.answer}
                                    >
                                        {/* <Radio.Group onChange={(e) => handleSelection(e.target.value, index)} > */}
                                        <Radio.Group
                                            className='d-block'
                                            onChange={(e) => handleSelection(e.target.value, element, index)} >
                                            <Row gutter={[8, { xs: 8, sm: 4, md: 4, lg: 4 }]} className="align-self-center align-items-center">
                                                <Col xs={24} sm={8} md={8} lg={8} xl={8} xxl={8} className="align-self-center align-items-center">
                                                    <Radio.Button value={element?.kapha}> {element?.kapha}</Radio.Button>
                                                </Col>
                                                <Col xs={24} sm={8} md={8} lg={8} xl={8} xxl={8} className="align-self-center align-items-center">
                                                    <Radio.Button value={element?.pitta}>{element?.pitta}</Radio.Button>
                                                </Col>
                                                <Col xs={24} sm={8} md={8} lg={8} xl={8} xxl={8} className="align-self-center align-items-center">
                                                    <Radio.Button value={element?.vata}>{element?.vata}</Radio.Button>
                                                </Col>
                                            </Row>
                                        </Radio.Group>
                                    </Form.Item>
                                </Col>
                            </Row>
                        ))
                    }


                    <Row>
                        <Col span={24} className="text-center">
                            <Button htmlType="submit" className="submit-button b-0 rounded">
                                SAVE
                            </Button>
                            <Button onClick={() => resetData()} className="reset-button ms-4 b-0 rounded">
                                RESET
                            </Button>
                        </Col>
                    </Row>
                </Form>
            </Spin>
        </div >
    )
}